import React from 'react';
import ReactDOM from 'react-dom/client';
import { APP_VERSION } from './version';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { registerLocale } from "react-datepicker";
import { uk } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";
import './styles/style.scss';
import App from './App';
import "./api/axiosInterceptor";

registerLocale("uk", uk);

console.log(`%c LAVA STUDIO v${APP_VERSION} `, 'background:#1a1a2e;color:#e0b554;font-size:14px;font-weight:bold;border-radius:4px;padding:4px 8px');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
